var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfoRound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.info-white{fill:#fff;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419 -1108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(419 1108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "info-white",
    d: "M.3.183.928.076V-2.9L.3-3.005v-.488H1.681V.076L2.3.183V.668H.3ZM1.681-4.559H.928v-.773h.753Z",
    transform: "translate(423.696 1116.332)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoRound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-round.d051c199.svg";
export { ForwardRef as ReactComponent };